import React, { useEffect, useState } from "react";

import ReplayPreview from "../components/ReplayPreview";
import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

function ChanelReplaysSensor({
  params,
  queryUrl,
  location,
  page,
  onDataUpdated,
}) {
  const [ready, setReady] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [visible, setVisible] = useState(false);
  const [replays, setReplays] = useState([]);

  const { t } = useTranslation();

  const onChange = (evt) => {
    if (evt && !visible) {
      console.log("sensor params", params);
      setFetching((f) => true);
      setVisible((v) => true);

      let search = location.search;
      if (!search.startsWith("?")) {
        search += "?page=" + page;
      } else {
        search += "&page=" + page;
      }
      Object.keys(params).forEach((key) => {
        search += "&" + key + "=" + params[key];
      });
      fetch(queryUrl + search)
        .then((r) => r.json())
        .then((_chanelOwner) => {
          setReplays((r) => _chanelOwner.last);
          onDataUpdated();
          setFetching((f) => false);
        })
        .catch((err) => {
          console.error("fetch problem", err);
          setFetching((f) => false);
          setVisible((v) => true);
        });
    }
  };

  useEffect(() => {
    setReady(false);
    let sensorTimer = setTimeout(() => {
      setReady(true);
    }, 3000);

    //FETCH HAND DETAILS
    return () => {
      clearTimeout(sensorTimer);
    };
  }, [params, location]);

  return (
    <>
      {replays.map((hand, index) => {
        return <ReplayPreview key={index} hand={hand}></ReplayPreview>;
      })}
      {!visible || fetching ? (
        <VisibilitySensor onChange={onChange}>
          <div className="sensor">{t("loading")}...</div>
        </VisibilitySensor>
      ) : replays.length === 10 && ready && !fetching ? (
        <ChanelReplaysSensor
          params={params}
          queryUrl={queryUrl}
          location={location}
          page={page + 1}
          onDataUpdated={onDataUpdated}
        ></ChanelReplaysSensor>
      ) : (
        <>:</>
      )}
    </>
  );
}
export default ChanelReplaysSensor;
